import { Link } from "react-router-dom";
import AssignedWorkDashboardEntry from "./AssignedWorkDashboardEntry";
import {
  ApplicationContextualHelp,
  ApplicationSectionHeader
} from "../../../components/application";

export default function DashboardParticipationSection() {
  return (
    <section
      aria-labelledby="dashboard-participation-title"
      className="av-dashboard-participation"
    >
      <ApplicationSectionHeader
        title={(
          <span className="av-app-section-header__title-row">
            <span>Activities with others</span>
            <ApplicationContextualHelp
              label="About activities with others"
              title="About activities with others"
            >
              <p>
                <Link to="/app/catalog">Catalog</Link> is the main place to
                explore activities and other resources you can use yourself.
                Activities with others brings together the ways you can use
                All-Voiced with other people: join through{" "}
                <Link to="/app/participate">Participate</Link> or run
                activities through{" "}
                <Link to="/app/facilitate">Facilitate</Link>.
              </p>
            </ApplicationContextualHelp>
          </span>
        )}
        titleId="dashboard-participation-title"
      />

      <div className="av-dashboard-participation__grid">
        <AssignedWorkDashboardEntry
          headingLevel={3}
          title={(
            <span className="av-app-section-header__title-row">
              <span>Participate</span>
              <ApplicationContextualHelp
                label="About Participate"
                title="About Participate"
              >
                <p>
                  Participate is where you access activities and spaces made
                  available to you by someone else. Join live sessions, access
                  your Projects, and—when available—complete assigned work.
                  Live sessions and assignments are created from{" "}
                  <Link to="/app/facilitate">Facilitate</Link>.
                </p>
              </ApplicationContextualHelp>
            </span>
          )}
          titleId="dashboard-participate-title"
          description="Join live sessions or access your projects."
          actionLabel="Open Participate"
          to="/app/participate"
        />
        <AssignedWorkDashboardEntry
          headingLevel={3}
          title={(
            <span className="av-app-section-header__title-row">
              <span>Facilitate</span>
              <ApplicationContextualHelp
                label="About Facilitate"
                title="About Facilitate"
              >
                <p>
                  Facilitate is where you run All-Voiced activities with other
                  people. Start live sessions now and, when Assignments become
                  available, create activities for selected participants to
                  complete on their own time. Participants join or access their
                  work from <Link to="/app/participate">Participate</Link>.
                </p>
              </ApplicationContextualHelp>
            </span>
          )}
          titleId="dashboard-facilitate-title"
          description="Start live sessions for activities you want to run with other people."
          actionLabel="Open Facilitate"
          icon="send"
          to="/app/facilitate"
        />
      </div>
    </section>
  );
}
